import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Typography, Box } from '@mui/material';

import { getQuizState } from '../../../store/QuizSlice';
import { getQuizHistory } from '../../../store/QuizSlice/QuizApi';
import { getAuthState } from '../../../store/AuthSlice';
import { useAppSelector } from '../../../hooks';
import MobileHeader from '../../../components/Mobile/Header';
import QuizHistoryJumbotron from './components/QuizHistoryJumbotron';
import QuizListItem from './components/QuizListItem';

const initalFilterData = {
  limit: 200,
  offset: 0,
};

const MyQuizHistory: React.FC = () => {
  const dispatch = useDispatch();

  // Store
  const quizState = useAppSelector(getQuizState);
  const authState = useAppSelector(getAuthState);

  useEffect(() => {
    if (authState.user) {
      dispatch(
        getQuizHistory({
          ...initalFilterData,
          userId: authState.user._id,
        })
      );
    }
  }, []);

  return (
    <div>
      <MobileHeader leftContents={{ type: 'drawer' }} />
      <QuizHistoryJumbotron />
      <Box style={{ padding: '30px 15px' }}>
        <div style={{ marginBottom: '30px' }}>
          {quizState.list.map((quiz, index) => (
            <QuizListItem key={index} quiz={quiz} />
          ))}
          {quizState.list.length === 0 && quizState.status !== 'loading' && (
            <Typography variant="h6">No Quizzes are available</Typography>
          )}
        </div>
      </Box>
    </div>
  );
};

export default MyQuizHistory;
